import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { interval } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ReleaseInfoComponent } from '../components/release-info/release-info.component';
import { environment } from '../../../../environments/environment';
import {
  ModalOptions,
  ModalService,
} from '../../../common_resource_modules/services/modal.service';

@Injectable({
  providedIn: 'root',
})
export class ReleaseService {
  constructor(
    public updates: SwUpdate,
    private modalService: ModalService,
  ) {
    if (environment.production && this.updates.isEnabled) {
      // Periodically check for updates every 5 seconds
      interval(5000).subscribe(() => {
        this.updates
          .checkForUpdate()
          .then(() => {
            console.log('Periodic update check triggered');
          })
          .catch((err) => {
            console.warn('Error during periodic update check:', err);
          });
      });

      // Listen for new version ready to activate
      this.updates.versionUpdates
        .pipe(
          filter(
            (evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY',
          ),
        )
        .subscribe(() => this.promptUser());
    } else {
      console.warn('Service Worker is not enabled or not in production mode');
    }
  }

  public checkForNewRelease(): void {
    if (!this.updates.isEnabled || !environment.production) {
      console.warn(
        'Service workers are disabled or not supported by this browser.',
      );
      return;
    }

    console.log('Manual check for update triggered');
    this.updates
      .checkForUpdate()
      .then(() => {
        console.log('Update check completed');
      })
      .catch((err) => {
        console.error('Manual update check failed:', err);
      });
  }

  private promptUser(): void {
    console.log('New version available – activating update');
    this.updates
      .activateUpdate()
      .then(() => {
        const options: ModalOptions = {
          backdrop: 'static',
          keyboard: false,
          centered: true,
        };
        this.modalService.openModal(ReleaseInfoComponent, 'md', options);
      })
      .catch((err) => {
        console.error('Update activation failed:', err);
      });
  }
}
